import { useQuery } from '@tanstack/react-query'

import { SoftwareApi, type SoftwareApiListData } from 'openapi'

export function useSoftwareListQuery(params: SoftwareApiListData) {
  return useQuery({
    queryKey: ['listSoftware', params],
    queryFn: () => {
      return SoftwareApi.list(params)
    },
  })
}
